import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { Button, Typography } from 'ui';
import { Form, Formik } from 'formik';
import { FunctionComponent } from 'react';
import { OfferingsPlatterWidgetFormFields } from 'components/consumer-page-widgets/offerings-platter-widget/OfferingsPlatterWidgetFormFields';
import { consumer } from '@tock/coretypes';
import {
  getBaseFormFieldsInitialValues,
  useUpdateNamedConfigurations,
} from 'components/consumer-page-widgets/widgetFormUtils';
import {
  widgetFormButtonContainer,
  widgetFormRoot,
} from 'components/consumer-page-widgets/widgetFormCssDefs';

interface UpdateOfferingsPlatterWidgetFormProps {
  selectedWidgetToEdit?: consumer.NamedConfiguration;
  onCompleteOrCancel(): void;
}

export const UpdateOfferingsPlatterWidgetForm: FunctionComponent<
  React.PropsWithChildren<UpdateOfferingsPlatterWidgetFormProps>
> = ({ selectedWidgetToEdit, onCompleteOrCancel }) => {
  const updateNamedConfig = useUpdateNamedConfigurations();

  if (!selectedWidgetToEdit?.offeringsPlatterWidgetConfig) {
    return null;
  }

  const handleSubmit = () => {
    return updateNamedConfig({
      ...selectedWidgetToEdit,
      offeringsPlatterWidgetConfig: {},
    }).then(onCompleteOrCancel);
  };

  return (
    <>
      <Typography variant="heading1Bold">Editing widget: {selectedWidgetToEdit.name}</Typography>
      <Formik
        enableReinitialize
        initialValues={{
          ...getBaseFormFieldsInitialValues({ widgetToEdit: selectedWidgetToEdit }),
        }}
        onSubmit={handleSubmit}
      >
        <Form css={widgetFormRoot}>
          <BaseWidgetFormFields />
          <OfferingsPlatterWidgetFormFields />
          <div css={widgetFormButtonContainer}>
            <Button type="submit">Submit</Button>
            <Button onClick={onCompleteOrCancel} type="button" variant="outlined">
              Cancel
            </Button>
          </div>
        </Form>
      </Formik>
    </>
  );
};
